import { render, staticRenderFns } from "./SideMenuApp.vue?vue&type=template&id=ce366ba6&"
import script from "./SideMenuApp.vue?vue&type=script&lang=js&"
export * from "./SideMenuApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports